@layer module {
.header-menu-wrapper {
            position: relative;
    }

.header-menu-trigger {
            cursor: pointer;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
    }

.header-menu-pill {
            border: none;
            white-space: nowrap;
    }

.header-menu-avatar {
            display: grid;
            place-items: center;
            flex-shrink: 0;
    }

.header-menu-dropdown {
            z-index: 1001;
            position: absolute;
            border: 1px solid;
            display: none;
    }

.header-menu-dropdown.opened {
            display: block;
    }

.header-menu-list {
            list-style: none;
    }

.header-menu-option {
            cursor: pointer;
            display: flex;
            align-items: center;
            border: none;
            text-align: left;
            text-decoration: none;
            white-space: nowrap;
    }

.header-menu-option svg {
            flex-shrink: 0;
    }

.header-menu-identity {
            display: flex;
            align-items: center;
            border-bottom: 1px solid;
    }

      @media (max-width: 1439px) {
                .header-menu-pill .header-menu-label {
                        display: none;
                    }
          }
} // layer module










@layer app {
.header-menu-trigger {
            height: $size-36;
    }

.header-menu-pill {
            gap: $size-8;
            height: $size-38;
            padding: 0 $size-12 0 $size-6;
            border-radius: $size-100;
    }

.header-menu-avatar {
            width: $size-26;
            height: $size-26;
            border-radius: 50%;
    }

.header-menu-dropdown {
            top: calc(100% + $size-8);
            right: 0;
            padding: $size-6;
            border-radius: $size-14;
    }

.header-menu-dropdown.upward {
            top: auto;
            bottom: calc(100% + $size-8);
            min-width: $size-240;
    }

.header-menu-list {
            margin: 0;
            padding: 0;
    }

.header-menu-option {
            gap: $size-10;
            width: 100%;
            min-height: $size-38;
            padding: $size-9 $size-12;
            border-radius: $size-10;
    }

.header-menu-identity {
            gap: $size-10;
            margin-bottom: $size-6;
            padding: $size-10 $size-12 $size-12;
    }

.header-menu-identity > div {
            min-width: 0;
    }

.header-menu-identity .header-menu-avatar {
            width: $size-30;
            height: $size-30;
    }

.header-menu-divider {
            height: 1px;
            margin: $size-6 $size-4;
    }

.header-menu-caption {
            padding: $size-6 $size-12 $size-4;
    }

.header-menu-wrapper {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: normal;
            line-height: $size-17;
    }

.header-menu-pill {
            background: var(--color-action);
            color: var(--color-on-action);
            font-size: var(--font-size-base);
            font-weight: 500;
            transition: box-shadow 0.2s ease;
    }

.header-menu-pill:hover {
            background: var(--color-action-hover);
    }

.header-menu-pill.opened,
.header-menu-pill:focus-visible {
            box-shadow: var(--shadow-header-menu-focus);
            outline: none;
    }

.header-menu-avatar {
            background: var(--color-brand);
            color: var(--color-on-brand);
            font-size: var(--font-size-sm);
            font-weight: 600;
    }

.header-menu-dropdown {
            background: var(--bg-surface);
            border-color: var(--border-default);
            box-shadow: var(--shadow-menu);
    }

.header-menu-option {
            background: transparent;
            color: var(--text-primary);
            font-size: var(--font-size-base);
            transition: background-color 0.15s ease;
    }

.header-menu-option svg {
            color: var(--text-body);
    }

.header-menu-option:hover {
            background: var(--page-canvas);
    }

.header-menu-option:global(.active-tab),
.header-menu-option.selected {
            background: var(--color-brand-wash);
            color: var(--color-brand);
            font-weight: 500;
    }

.header-menu-option:global(.active-tab) svg,
.header-menu-option.selected svg {
            color: currentColor;
    }

.header-menu-option.danger {
            color: var(--color-error-text);
            font-weight: 500;
    }

.header-menu-option.danger svg {
            color: currentColor;
    }

.header-menu-identity {
            border-color: var(--border-light);
    }

.header-menu-identity .header-menu-avatar {
            font-size: var(--font-size-sm);
    }

.header-menu-identity-name {
            font-weight: 600;
    }

.header-menu-identity-email {
            overflow: hidden;
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.header-menu-divider {
            background: var(--border-light);
    }

.header-menu-caption {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
            font-weight: 500;
            letter-spacing: 0.04em;
            text-transform: uppercase;
    }
} // layer app










@layer context {
:global(.transactions-page) .header-menu-trigger:global(.export-trigger) {
            gap: $size-7;
            height: $size-34;
            padding: 0 $size-14;
    }
} // layer context
